import { motion } from "framer-motion";

export const BrandLogos = (props:any) => {

  return (
    <section className="relative py-24 text-white overflow-hidden">
      {/* BG Grid */}
      <div className="absolute inset-0 opacity-[0.09]">
        <svg width="100%" height="100%">
          <defs>
            <pattern
              id="circuit"
              width="80"
              height="80"
              patternUnits="userSpaceOnUse"
            >
              <path
                d="M 10 0 V 80 M 40 0 V 80 M 70 0 V 80"
                stroke="white"
                strokeWidth="0.4"
              />
              <path
                d="M 0 10 H 80 M 0 40 H 80 M 0 70 H 80"
                stroke="white"
                strokeWidth="0.4"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#circuit)">
            <animate
              attributeName="x"
              from="0"
              to="40"
              dur="10s"
              repeatCount="indefinite"
            />
          </rect>
        </svg>
      </div>

      {/* Gradient Glows */}
      <div className="absolute -top-20 left-0 w-96 h-96 bg-red-600/10 blur-[140px]"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-blue-600/10 blur-[160px]"></div>

      {/* ------------------ CONTENT ------------------ */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        {/* Modern Title */}
        <h2 className="text-3xl md:text-4xl font-bold mb-8 tracking-wide">
          <span className="text-gray-500">{props.title}</span>{" "}
          <span className="text-red-500 uppercase">{props.subTitle}</span>
        </h2>

        {/* Logos Row */}
        <div className="max-w-7xl mx-auto px-6 flex flex-wrap justify-center items-center gap-18 md:gap-20">
          {props.logoList.map((l:any, i:number) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 25 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              whileHover={{
                scale: 1.12,
                y: -4,
                transition: { duration: 0.3 },
              }}
              className="opacity-80 hover:opacity-100 transition cursor-pointer"
            >
              <img
                src={l.img}
                alt={l.name}
                className="h-[180px] w-auto brightness-90 hover:brightness-110 transition"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
